import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("sq_token")) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("sq_token");
      api.post("/auth/logout").catch(() => {});
      setUser(false);
    });
  }, []);

  const loginWithSession = async (sessionId) => {
    const { data } = await api.post("/auth/session", { session_id: sessionId });
    localStorage.setItem("sq_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("sq_token");
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, loginWithSession, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen admin-grid-bg" />;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
